<template>
  <div class="app">
    <AppHeader fixed>
      <div class="ml-3 mr-3">CRM | Malinowe Hotele</div>
      <SidebarToggler class="d-lg-none" display="md" mobile/>
      <SidebarToggler class="d-none" display="lg"/>
      <div class="ml-auto" style="padding-right: 15px;">
        <a @click="logout" role="button">
          <i class="icon-logout"></i>
          {{ $t('common.logout')}}
        </a>
      </div>
    </AppHeader>
    <div class="app-body">
      <AppSidebar>
        <div class="sidebar">
          <nav class="sidebar-nav">
            <section class="ps-container scroll-area ps ps--theme_default">
              <ul class="nav">
                <li class="nav-item">
                  <router-link :to="{name: 'dashboard'}" class="nav-link">
                    <i class="nav-icon icon-speedometer"></i>
                    Panel
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link :to="{name: 'clients'}" class="nav-link">
                    <i class="nav-icon icon-people"></i>
                    Klienci
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link :to="{name: 'loyaltyCards'}" class="nav-link">
                    <i class="nav-icon icon-credit-card"></i>
                    Karty lojalnościowe
                  </router-link>
                </li>
                <li class="nav-item" v-has-permissions="50">
                  <router-link :to="{name: 'manualPersons'}" class="nav-link">
                    <i class="nav-icon icon-ban"></i>
                    Do zatwierdzenia
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link :to="{name: 'exports'}" class="nav-link">
                    <i class="nav-icon icon-chart"></i>
                    Eksport
                  </router-link>
                </li>
                <li class="nav-item" v-has-permissions="80">
                  <router-link :to="{name: 'users'}" class="nav-link">
                    <i class="nav-icon icon-people"></i>
                    Użytkownicy
                  </router-link>
                </li>
                <li class="nav-item" v-has-permissions="99">
                  <router-link :to="{name: 'invoices'}" class="nav-link"><i
                      class="nav-icon fa fa-usd"></i> Faktury
                  </router-link>
                </li>
                <li class="nav-item" v-has-permissions="99">
                  <router-link :to="{name: 'logs'}" class="nav-link">
                    <i class="nav-icon icon-calendar"></i>
                    Rejestr zdarzeń
                  </router-link>
                </li>
                <li class="nav-item">
                  <router-link :to="{name: 'settings'}" class="nav-link">
                    <i class="nav-icon icon-settings"></i>
                    Ustawienia
                  </router-link>
                </li>
              </ul>
            </section>
          </nav>
        </div>

        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <div class="container-fluid">
          <router-view/>
        </div>
      </main>
    </div>
    <TheFooter>
      <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="https://www.selon.pl" target="_blank">SELON</a>
      </div>
    </TheFooter>
  </div>
</template>

<script>
  import auth from '@Service/auth';
  import {
    Header as AppHeader,
    SidebarToggler,
    Sidebar as AppSidebar,
    SidebarMinimizer,
    SidebarNav,
    Footer as TheFooter,
  } from '@coreui/vue';

  export default {
    components: {
      AppHeader,
      AppSidebar,
      TheFooter,
      SidebarToggler,
      SidebarNav,
      SidebarMinimizer
    },
    methods: {
      logout() {
        auth.logout();
      },
    },
  };
</script>
<style>
  a {
    cursor: pointer;
  }

  .main {
    padding-top: 30px;
  }
</style>
